import * as React from "react";
const SvgArrowDownSmall = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.04 10.271a.75.75 0 1 0-1.078-1.043l-3.837 3.966L8.29 9.228a.75.75 0 0 0-1.078 1.043l4.375 4.523a.745.745 0 0 0 .792.185.746.746 0 0 0 .286-.185l4.376-4.523Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgArrowDownSmall;
